// Accepted range for an operator-supplied battery capacity, kept in sync with the API
// schema (`batteryCapacityKwh`). The bounds exist to catch unit confusion — an MWh or Wh
// figure typed into a kWh field — not proportionate typos: a wrong-but-plausible value is
// caught by comparing against what the inverter reports, not by these numbers.
//
// Shared by the onboarding modal and the edit modal so the two inputs cannot drift apart
// from each other or from the schema.
export const MIN_CAPACITY_KWH = 1;
export const MAX_CAPACITY_KWH = 1000;
